import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { MessageService } from 'src/app/data-services/message.service';
import { PostService } from 'src/app/data-services/post.service';
import { first } from 'rxjs/operators';
import { NgForm, FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-iffhsposts',
  templateUrl: './iffhsposts.component.html',
  styleUrls: ['./iffhsposts.component.css']
})
export class IffhspostsComponent implements OnInit {
  token: string;
  commentForm: FormGroup;
  currentUser: any;
  userData: any = [];
  language = '';
  direction = '';
  submitted: boolean;
  defaultLanguage;
  Clubnews:any;
  posts2 : any;
  errorFlag: boolean;
  comments:any;
  comnew:any;
  visible: boolean;
  selectNews: any = {};
  slider: any = {};
  id: any;
  role: any;
  isLoaderVisible = false;
  iffhspost2:any;
  views:any;
  commentusers:any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private messageService: MessageService,
    private postService : PostService,
    private http:HttpClient,
    public fb:FormBuilder
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.messageService.selectedLanguage.subscribe(res => {
      console.log(res);
      this.language = res.lang;
      this.direction = res.dir;
    });
  }

  
  ngOnInit(): void {
    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
    this.language = this.defaultLanguage.lang;

    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
    });

    this.getpost();
    this.getpostcomant();
    this.getProfile();
    this.commentForm = this.formBuilder.group({
      username: [this.currentUser.success.user.fullName],
      useremail: [this.currentUser.success.user.email],
      UserComment: ['', Validators.required],
      Post_id: [this.id],
    });
  }

  getProfile() {
    const data = {
      id: this.currentUser.success.user.id,
      role: this.currentUser.success.user.role,
    };
    this.userService.getProfile(data).subscribe((res: any) => {
      this.userData = res;
      this.messageService.sendMessage(this.userData);
      localStorage.setItem('userData', JSON.stringify(this.userData));
    });
  }

  getpost()
  {
    this.isLoaderVisible = true;
    const data ={
      id: this.id,
    };
    
    this.postService.getSinglePost(data).subscribe(
      res =>this.iffhspost2 =res
    );
    this.postService.getviewsPost(data).pipe().subscribe(
      data =>this.views =data
    );
    this.isLoaderVisible = false;
  }

  getpostcomant()
  {
    const data2 = {
      Post_id: this.id,
    };
    this.postService.getcommant(data2).pipe().subscribe(
      res =>{
        this.commentusers =res;
        console.log(this.commentusers);
    });
  }
  setcommPost()
  {
    this.isLoaderVisible = true;
    this.submitted = true;
    this.errorFlag = false;
    if (this.commentForm.invalid) {
      return;
    }
    var fd1:any = new FormData();
    fd1.append('username', this.commentForm.get('username').value);
    fd1.append('useremail', this.commentForm.get('useremail').value);
    fd1.append('UserComment', this.commentForm.get('UserComment').value);
    fd1.append('Post_id', this.commentForm.get('Post_id').value);
    this.postService.putcommant(fd1).subscribe(
      response => {
        this.toastrService.success('Thanks for share with us , Your voting is sended', 'Message!');
        this.visible = false;
        this.isLoaderVisible = false;
        this.errorFlag = false;
        this.submitted = true;
        this.getpost();
        this.getpostcomant();
        this.getProfile();
      },
      error => {
        console.log(error);
        this.toastrService.error('Something went wrong Try again', 'Message!');
        this.isLoaderVisible = false;
        this.visible = false;
        this.errorFlag = false;
      }
    );
    this.commentForm = this.formBuilder.group({
      UserComment: [''],
    });
  } 
  getformat(sentnumber){
    if(sentnumber == 0) {
    return 0;
    }
    else
    {        
      // hundreds
      if(sentnumber <= 999){
        return sentnumber ;
      }
      // thousands
      else if(sentnumber >= 1000 && sentnumber <= 999999){
        return (sentnumber / 1000).toFixed(2) + ' K';
      }
      // millions
      else if(sentnumber >= 1000000 && sentnumber <= 999999999){
        return (sentnumber / 1000000).toFixed(3) +' M';
      }
      // billions
      else if(sentnumber >= 1000000000 && sentnumber <= 999999999999){
        return (sentnumber / 1000000000).toFixed(3) + ' B';
      }
      else
        return sentnumber ;
      }
}
calculateDiff(sentDate) {
  var date1:any = new Date(sentDate);
  var date2:any = new Date();
  var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30 * 12));
  if(diffDays == 0)
  {
    var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30));
    if(diffDays == 0)
    {
      var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 ));
      if(diffDays == 0)
      {
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60));
        if(diffDays == 0)
        {
          var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 ));
          if(diffDays == 0)
          {
            
          }
          else
          {
            return diffDays +" minutes ago";
          }
        }
        else
        {
          return diffDays +" hours ago";
        }
      }
      else
      {
        return diffDays +" day ago";
      }
    }
    return diffDays +" month ago";
  }
  else
  {
    return diffDays +" year ago";
  }
}
}
